import { enc, request } from './http';

export const listRules = (options) => request('GET', `/api/madar/rules`, undefined, options);
export const getSchema = (options) => request('GET', `/api/madar/rules/schema`, undefined, options);
export const getCopySources = (options) => request('GET', `/api/madar/rules/copy-sources`, undefined, options);
export const getVersion = (id, options) => request('GET', `/api/madar/rules/versions/${enc(id)}`, undefined, options);
export const createDraft = (body, options) => request('POST', `/api/madar/rules/drafts`, body, options);
export const saveVersion = (id, body, options) => request('PUT', `/api/madar/rules/versions/${enc(id)}`, body, options);
export const publishVersion = (id, body, options) => request('POST', `/api/madar/rules/versions/${enc(id)}/publish`, body, options);
export const deleteVersion = (id, options) => request('DELETE', `/api/madar/rules/versions/${enc(id)}`, undefined, options);
